<div
  *ngIf="dynamicSchema"
  [formGroup]="dynamicForm"
  [class.indent]="dynamicSchema?.indent"
>
  <ng-container *ngIf="!(isHidden$ | async)">
    <ix-scheduler
      *ngIf="dynamicSchema.type === DynamicFormSchemaType.Cron"
      [formControlName]="dynamicSchema.controlName"
      [label]="dynamicSchema.title | translate"
      [tooltip]="dynamicSchema.tooltip | translate"
      [required]="dynamicSchema.required"
    ></ix-scheduler>

    <ng-container *ngIf="dynamicSchema.type === DynamicFormSchemaType.Dict">
      <div class="label">
        <div class="label-wrapper">
          {{ dynamicSchema.title }}
        </div>

        <div *ngIf="dynamicSchema.tooltip" class="label-tooltip">
          <ix-tooltip
            class="tooltip"
            [header]="dynamicSchema.title"
            [message]="dynamicSchema.tooltip"
          ></ix-tooltip>
        </div>
      </div>
      <ix-dynamic-form-item
        *ngFor="let attr of dynamicSchema.attrs"
        [dynamicSchema]="attr"
        [dynamicForm]="dynamicForm.controls[dynamicSchema.controlName] | cast"
        [isEditMode]="isEditMode"
        (addListItem)="addControlNext($event)"
        (deleteListItem)="removeControlNext($event)"
      ></ix-dynamic-form-item>
    </ng-container>

    <ix-list
      *ngIf="dynamicSchema.type === DynamicFormSchemaType.List"
      [label]="dynamicSchema.title | translate"
      [empty]="getFormArray.controls.length === 0"
      [formArrayName]="dynamicSchema.controlName"
      [default]="dynamicSchema.default"
      [itemsSchema]="dynamicSchema.itemsSchema"
      [isEditMode]="isEditMode"
      (add)="addControl($event)"
    >
      <ix-list-item
        *ngFor="let element of getFormArray.controls; let i = index"
        (delete)="removeControl(i)"
      >
        <ix-dynamic-form-item
          *ngFor="let item of dynamicSchema.items"
          class="list"
          [dynamicSchema]="item"
          [dynamicForm]="element | cast"
          [isEditMode]="isEditMode"
          (addListItem)="addControlNext($event)"
          (deleteListItem)="removeControlNext($event)"
        ></ix-dynamic-form-item>
      </ix-list-item>
    </ix-list>

    <ix-input
      *ngIf="
        dynamicSchema.type === DynamicFormSchemaType.Input ||
        dynamicSchema.type === DynamicFormSchemaType.Uri
      "
      [formControlName]="dynamicSchema.controlName"
      [label]="dynamicSchema.title | translate"
      [placeholder]="dynamicSchema.placeholder | translate"
      [tooltip]="dynamicSchema.tooltip | translate"
      [required]="dynamicSchema.required"
      [type]="dynamicSchema.inputType"
    ></ix-input>

    <ix-select
      *ngIf="dynamicSchema.type === DynamicFormSchemaType.Select"
      [formControlName]="dynamicSchema.controlName"
      [label]="dynamicSchema.title | translate"
      [options]="dynamicSchema.options"
      [tooltip]="dynamicSchema.tooltip | translate"
      [required]="dynamicSchema.required"
      [hideEmpty]="dynamicSchema.hideEmpty"
    ></ix-select>

    <ix-explorer
      *ngIf="dynamicSchema.type === DynamicFormSchemaType.Explorer"
      [formControlName]="dynamicSchema.controlName"
      [label]="dynamicSchema.title | translate"
      [tooltip]="dynamicSchema.tooltip | translate"
      [required]="dynamicSchema.required"
      [nodeProvider]="dynamicSchema.nodeProvider"
    ></ix-explorer>

    <ix-checkbox
      *ngIf="dynamicSchema.type === DynamicFormSchemaType.Checkbox"
      [formControlName]="dynamicSchema.controlName"
      [label]="dynamicSchema.title | translate"
      [tooltip]="dynamicSchema.tooltip | translate"
      [required]="dynamicSchema.required"
    ></ix-checkbox>

    <ix-ip-input-with-netmask
      *ngIf="dynamicSchema.type === DynamicFormSchemaType.Ipaddr"
      [formControlName]="dynamicSchema.controlName"
      [label]="dynamicSchema.title | translate"
      [tooltip]="dynamicSchema.tooltip | translate"
      [required]="dynamicSchema.required"
    ></ix-ip-input-with-netmask>
  </ng-container>
</div>
